module.exports = __webpack_public_path__ + "img/logo-page.e2e0e252.png";